import { IsArraysHas, IsArraysContains } from '../../helpers/helpers';

import AuthService from '../Auth/auth.modules';
import References from '../../helpers/Reference';

export function SearchByMCHS( station, mchs, orAnd ) {
    let condFilter = true;
    if (mchs.length > 0) {
        let stationMCHS = station.mchs.map( item => item.type);
        if (station.photo)
            stationMCHS.push( 'photo' );
        condFilter = orAnd === 'or' ? IsArraysHas( mchs, stationMCHS ) : IsArraysContains( mchs, stationMCHS );            
    } 
    return condFilter;
}

export function SearchByAreas( station, areas ) {
    return areas.length === 0 || areas.indexOf(station.holder_uuid) > -1;
}

export async function loadAreas() {
    return AuthService.fetch(References.api.area)
        .then(res => res.json())
        .catch(() => console.log('need auth'));
}

export function parseAreas( areas ) {
    if (!areas)
        return [];
    const result = Object.keys( areas ).map( key => {
        let result = areas[key];
        result.uuid = key;
            result.children = 
            areas[key].hasOwnProperty('children') ?            
                areas[key]?.children.map(item => {
                    const index = Object.keys(item)[0];
                    let children = item[index];
                    children.uuid = index;
                    return children;
                }) : [];
        return result;
    });
    return result;
}